export enum OperatorType {
  And = 'and',
  Or = 'or',
}
